<template>
  <section v-lenis-scroll class="takat-tabs-banner" :style="marginTopBottom">
    <div class="takat-tabs-container">
      <img
        v-lazy="shopifyData.logoImage"
        :alt="shopifyData.logoAlt || 'Takat Logo'"
        class="takat-tabs-logo"
        loading="lazy"
        aria-hidden="true"
        aria-label="Takat Logo"
        width=""
        height=""
      />
      <ul class="list_btnTab staggerEffect">
        <li
          v-for="(button, index) in shopifyData.buttonData"
          :key="index"
          class="btn_tab_item animbtn"
        >
          <a :href="button.link" class="btn_tab_link">{{ button.title }}</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    marginTopBottom() {
      if (!this.shopifyData) return {};
      const { deskMarginTop, mobMarginTop, deskMarginBottom, mobMarginBottom, bgColor } =
        this.shopifyData;
      const isDesktop = window.innerWidth > 768;
      return {
        'padding-top': `${isDesktop ? deskMarginTop : mobMarginTop || 0}px`,
        'padding-bottom': `${isDesktop ? deskMarginBottom : mobMarginBottom || 0}px`,
        'background-color': bgColor || '#d7d293',
      };
    },
  },
  created() {
    window.addEventListener('resize', this.marginTopBottom);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.marginTopBottom);
  },
  methods: {
    handleResize() {
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.takat-tabs-banner {
  position: relative;
}

.takat-tabs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* height: 100vh; */
  gap: 125px;
  text-align: center;
}

.takat-tabs-logo {
  max-width: 70px;
  width: 100%;
  display: block;
}

.list_btnTab.staggerEffect {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
}

.btn_tab_link {
  padding: 7px;
  background-color: #485c6f;
  font-family: 'Adobe Caslon Pro', serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.8px;
  letter-spacing: 0.02em;
  text-decoration: none;
  color: #d9d38e;
  display: block;
  min-width: 114px;
  width: 100%;
  transition: 0.3s;
}

.btn_tab_link:hover {
  background-color: #41505e;
  color: #d9d38e;
}

@media only screen and (max-width: 768px) {
  .list_btnTab.staggerEffect {
    flex-direction: column;
    gap: 11px;
  }

  .takat-tabs-container {
    gap: 80px;
  }

  .btn_tab_link {
    min-width: 145px;
  }
  .takat-tabs-logo {
    max-width: 50px;
  }
}
</style>
